import {
  GET_USERINFO,
  GET_USERINFO_SUCCESSED,
  GET_USERINFO_FAILED,
  UPDATE_USERINFO,
  UPDATE_USERINFO_SUCCESSED,
  SAVE_SECURITYQUESTIONS,
  SAVE_SECURITYQUESTIONS_FAILED,
  SAVE_SECURITYQUESTIONS_SUCCESSED
} from '../actions/actionTypes'

const initialState = {
  data: {question1: null, question2: null, question3: null, answer1: null, answer2: null, answer3: null,emptyQuestions:false},
  requesting_get: false,
  requesting_get_successful: false,
  requesting_update:false,
  requesting_update_successful:false,
  requesting_save: false,
  requesting_save_successful: false,
  message: null,
  loading_message: "Loading userinfo..."
}

function userInfoReducers(state = initialState, action) {
  switch (action.type) {
    case GET_USERINFO:
      return Object.assign({}, {
        requesting_get: true,
        requesting_get_successful: false,
        data: Object.assign({}, state.data),
        message: null,
        loading_message: "Loading userinfo..."
      })
    case GET_USERINFO_SUCCESSED:
      return Object.assign({}, {
        requesting_get: false,
        requesting_get_successful: true,
        data: Object.assign({}, action.data),
        message: null,
        loading_message: state.loading_message
      })
    case GET_USERINFO_FAILED:
      return Object.assign({}, {
        requesting_get: false,
        requesting_get_successful: false,
        data: Object.assign({}, state.data),
        message: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.",
        loading_message: state.loading_message
      })

      //update userinfo
      case UPDATE_USERINFO:
        return Object.assign({}, {
          requesting_update: true,
          requesting_update_successful: false,
          data: Object.assign({}, state.data),
          message: null,
          loading_message: "Updating userinfo..."
        })
      case UPDATE_USERINFO_SUCCESSED:
        return Object.assign({}, {
          requesting_update: false,
          requesting_update_successful: true,
          data: Object.assign({}, action.data),
          message: null,
          loading_message: state.loading_message
        })
      //save security questions
      case SAVE_SECURITYQUESTIONS:
        return Object.assign({}, {
          requesting_save: true,
          requesting_save_successful: false,
          data: Object.assign({}, state.data),
          message: null,
          loading_message: "Saving security questions..."
        })
      case SAVE_SECURITYQUESTIONS_SUCCESSED:
        return Object.assign({}, {
          requesting_save: false,
          requesting_save_successful: true,
          data: Object.assign({}, action.data,{answer1:null,answer2:null,answer3:null}),
          message: null,
          loading_message: state.loading_message
        })
      case SAVE_SECURITYQUESTIONS_FAILED:
        return Object.assign({}, {
          requesting_save: false,
          requesting_save_successful: false,
          data: Object.assign({},state.data),
          message: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.",
          loading_message: state.loading_message
        })
    default:
      return state
  }
}

export default userInfoReducers;
